import { render, staticRenderFns } from "./NewInsurancePolicyPro.vue?vue&type=template&id=2e1c94de&scoped=true&"
import script from "./NewInsurancePolicyPro.vue?vue&type=script&lang=js&"
export * from "./NewInsurancePolicyPro.vue?vue&type=script&lang=js&"
import style0 from "./NewInsurancePolicyPro.vue?vue&type=style&index=0&id=2e1c94de&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1c94de",
  null
  
)

export default component.exports